import { Component, OnInit, Inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { FileUploadValidators } from '@iplab/ngx-file-upload';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from 'src/app/utils/loader.service';
import { AdminService } from '../../admin.service';

interface DialogData {
  bDisabled: boolean
}

@Component({
  selector: 'app-upload-document',
  templateUrl: './upload-document.component.html',
  styleUrls: ['./upload-document.component.scss']
})
export class UploadDocumentComponent implements OnInit {

  proofUploaded: boolean;
  uploaded_file_name="";
  payment_file: any;
  uploadFilepaths: any;
  fileUploadLoading: boolean = false;
  resData: any;

  constructor(   public dialogref: MatDialogRef<UploadDocumentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private adminService: AdminService,
    private toastr: ToastrService,
    private loaderService: LoaderService) { }

  private paymentfilesControl = new FormControl(null, FileUploadValidators.filesLimit(1));
  public demoForm = new FormGroup({
    files: this.paymentfilesControl
  });
  
  ngOnInit(): void {
    this.resData = this.data["resData"];
  }

  submit()
  {
    this.loaderService.display(true);
    let formData = new FormData();

     formData.append('loanfies', this.demoForm.value.files[0]);

    this.adminService.addloanfiles(formData).subscribe(
      res => {
        this.toastr.success('Loan file has been Submitted', 'Success');
        this.loaderService.display(false);
        this.close();
      },
      err => {
        this.toastr.error('Something went Wrong', 'Error');
        this.loaderService.display(false);
        this.close();
      }

    );
  }

  close() {
    this.dialogref.close();
  }

  removeFile()
  {
    this.uploaded_file_name = '';
  }

}